export const checkFillValue = (currentValue?: unknown, nestedName?: string) => {
  let isFullFilled = false;

  if (!Array.isArray(currentValue) && currentValue) {
    isFullFilled = true;
  } else {
    isFullFilled = false;
  }

  if (Array.isArray(currentValue) && currentValue.length) {
    currentValue.forEach(nestedItem => {
      if (nestedItem && 'value' in nestedItem && nestedItem.value) {
        isFullFilled = true;
      } else if (nestedName && nestedItem && nestedName in nestedItem && nestedItem[nestedName]) {
        isFullFilled = true;
      } else {
        isFullFilled = false;
      }
    });
  }

  return isFullFilled;
};
